import React from "react";
import CustomLabel from "../customLabel";
import colors from "../../../../config/colors";
import { labelRegistro } from "../../../global/styles";
import { useSelector } from "react-redux";

const LabelRegistro = ({ style, isUltra }) => {
  const ultraDarkMode = useSelector((state) => state.afiliado.infoAfiliado.ultraDarkMode);
  const isDark = isUltra && ultraDarkMode;
  const isUltraLight = isUltra && !ultraDarkMode;

  const titleColor = isDark ? colors.ultraSilver : isUltraLight ? colors.ulText : undefined;
  const accentColor = isDark ? colors.ultraAccentLight : isUltraLight ? colors.ulAccent : colors.primary;
  return (
    <CustomLabel style={{ ...labelRegistro, ...style, lineHeight: 1, color: titleColor }}>
      OFICINA <br /> VIRTUAL PARA <br />
      <label style={{ color: accentColor }}>AFILIADOS </label>
    </CustomLabel>
  );
};

export default LabelRegistro;
